import classNames from "clsx";
import Link from "next/link";
import { useTranslations } from "next-intl";
import { HiArrowNarrowLeft, HiArrowNarrowRight } from "react-icons/hi";

import { Text } from "@shared/elements";

import { MESSAGE_PREFIX } from "src/constants";

type PaginationProps = {
  getPageLink: (page: PaginationProps["page"]) => string;
  pages: number;
  page: number;
};

export default function Pagination({
  getPageLink,
  pages,
  page,
}: PaginationProps) {
  const t = useTranslations(`${MESSAGE_PREFIX}components.Pagination`);
  const hasPrev = page > 1;
  const hasNext = page < pages;
  const iconStyles =
    "text-gray-400 w-5 h-5 inline hover:text-gray-500 focus:text-gray-400";
  const textStyles =
    "hover:text-gray-600 focus:text-gray-500 flex items-center";
  const textProps = {
    as: Link,
    size: "sm",
    weight: "medium",
    color: "muted",
  };

  return (
    <div className="border-gray-200 border-t flex justify-between content-center pt-4 px-4 md:px-0">
      {hasPrev ? (
        <Text
          // @ts-expect-error FIXME: make types work properly for Text
          href={getPageLink(page - 1)}
          className={classNames("mr-auto", textStyles)}
          {...textProps}
        >
          <HiArrowNarrowLeft className={classNames("mr-3", iconStyles)} />
          {t("prev")}
        </Text>
      ) : null}
      {hasNext ? (
        <Text
          // @ts-expect-error FIXME: make types work properly for Text
          href={getPageLink(page + 1)}
          className={classNames("ml-auto", textStyles)}
          {...textProps}
        >
          {t("next")}
          <HiArrowNarrowRight className={classNames("ml-3", iconStyles)} />
        </Text>
      ) : null}
    </div>
  );
}

Pagination.messages = [`${MESSAGE_PREFIX}components.Pagination`];
